module.exports = __webpack_public_path__ + "img/cards.bb45ce5a.png";